import { get, compact } from 'lodash';
import { required } from 'vee-validate/dist/rules';

export function register(extend, i18n) {

    // Validates that the default language is set
    extend('required_default_lang', {
        message: field => i18n.t('validations.default_lang_required', [field]).toString(),
        params: [
            {
                name: 'allowFalse',
                default: true
            },
            {
                name: 'event',
                required: true,
            },
            {
                name: 'model',
                required: true
            },
            {
                name: 'field',
                default: null
            },
            {
                name: 'translationsKey',
                default: null
            }
        ],
        computesRequired: true,
        validate: (value, { allowFalse, model, event, field, translationsKey }) => {
            const isMultilingual = event.languages?.length > 1;

            if (isMultilingual) {
                const defaultLang = event.languages?.[0];
                value = get(model, compact([translationsKey, defaultLang, field])) || model[field];
            }

            return required.validate(value, { allowFalse });
        }
    });
}
